import { useState } from "react";
import { notification_color_keys } from "utils/hooks";
import { logError } from "utils/error";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { TRANSACTION_APIS } from "../../../transactions.apis";
import { apiMethods } from "data/api.constants";

export const useRetryRefund = ({ record, refresh, notify }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const { mutate: retryRefund } = useCustomMutation({
    url: TRANSACTION_APIS.refund_history_retry,
    method: apiMethods.POST,
    returnFullResponse: true,

    onSuccess: (response) => {
      notify(response?.message, notification_color_keys.success);
      refresh();
    },

    onError: async (error) => {
      await logError({
        error,
        when: "Retry refund API failed",
        occuredAt:
          "src/ui/pages/transactions/RefundHistory/hooks/useRetryRefund.js",
      });

      notify(
        error?.response?.data?.message || error?.message,
        notification_color_keys.error
      );
    },
  });

  const handleRetryOnClick = (event) => {
    event.stopPropagation();

    handleMenuClose();

    retryRefund({
      order_uuid: record.order_uuid,
    });
  };

  return {
    anchorEl,
    handleMenuClick,
    handleMenuClose,
    handleRetryOnClick,
  };
};
